import { render, staticRenderFns } from "./MonriCardForm.vue?vue&type=template&id=0e846acd&scoped=true"
import script from "./MonriCardForm.vue?vue&type=script&lang=js"
export * from "./MonriCardForm.vue?vue&type=script&lang=js"
import style0 from "./MonriCardForm.vue?vue&type=style&index=0&id=0e846acd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e846acd",
  null
  
)

export default component.exports